import { Box, Stack } from "../../internal/exports";

import { Select } from "../../select/select";

import { QuestionWithHeaderAndFooter } from "../question";
import { QuestionContent } from "../question-content";
import { RankingQuestionProps } from "../types";

export const RankingQuestion = (props: RankingQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    questionId,
    labelClassName,
    questionLabel,
    questionLabelType,
    layoutProps,
    accessibilityTextOfRequired,
    questionLabelProps,
    contentLayoutProps,
    answer,
    isClearable,
    size,
    placeholder,
    handleChange,
    answerStackSpacing,
    answerGroupSpacing,
    options,
    rankRange,
    answerLabelProps,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    getRankingSelectDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    layoutProps,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent gap={answerStackSpacing} {...contentLayoutProps}>
        {options &&
          options.map((option) => (
            <Stack key={option.id} gap={answerGroupSpacing}>
              <Box as="label" htmlFor={`${option.id}`} {...answerLabelProps}>
                {option.name}
              </Box>
              <Select
                size={size}
                isClearable={isClearable}
                options={rankRange}
                inputId={`${option.id}`}
                value={
                  answer[option.id]
                    ? {
                        label: answer[option.id] ?? "",
                        value: answer[option.id] ?? ""
                      }
                    : null
                }
                isOptionDisabled={({ value }: { value: number }) => {
                  return (
                    answer[option.id] !== value &&
                    Object.values(answer).indexOf(value) !== -1
                  );
                }}
                placeholder={placeholder}
                onChange={(e: { value: string }) => handleChange(e, option?.id)}
                {...answerProps}
                data-testid={getRankingSelectDataTestId?.(option.id)}
              />
            </Stack>
          ))}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
